import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import { authenticatingUserSucceeded } from 'actions/users';

import _ from "lodash";

export default function SsoSuccess() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const authenticated = useSelector((state) =>_.get(state, "users.authentication.authenticated"));

  useEffect(() => {
    const response = new URLSearchParams(location.search).get("response");
    if (response) {
      processSuccessResponse(response);
    }
  }, [location.search]);

  useEffect(() => {
    if (authenticated) {
      history.push("/");
    }
  }, [authenticated])

  const processSuccessResponse = (response) => {
    const decoded = atob(response);
    const jsonData = JSON.parse(decoded);
    dispatch(authenticatingUserSucceeded(jsonData));
  };

  return null;
}